(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mitoq-slider-product"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
$('.mitoq-slider-product-section .mitoq-slider-tabs').slick({
infinite: true,
slidesToShow: 1,
arrows: false,
focusOnSelect: true,
asNavFor: '.mitoq-slider-content-slider',
responsive: [
{ breakpoint: 768, settings: { slidesToShow: 1 } },
{ breakpoint: 480, settings: { slidesToShow: 1 } }
]
});

$('.mitoq-slider-content-slider').slick({
// fade: true,
arrows: true,
asNavFor: '.mitoq-slider-tabs'
});

$('#arrow-prev').click(function() {
$('.mitoq-slider-content-slider').slick('slickPrev');
});

$('#arrow-next').click(function() {
$('.mitoq-slider-content-slider').slick('slickNext');
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mitoq-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
$('.mitoq-slider-tabs').slick({
infinite: true,
slidesToShow: 5,
arrows: false,
focusOnSelect: true,
asNavFor: '.mitoq-slider-content-slider',
responsive: [
{ breakpoint: 768, settings: { slidesToShow: 2 } },
{ breakpoint: 480, settings: { slidesToShow: 2 } }
]
});

$('.mitoq-slider-content-slider').slick({
// fade: true,
arrows: true,
asNavFor: '.mitoq-slider-tabs'
});

$('#arrow-prev').click(function() {
$('.mitoq-slider-content-slider').slick('slickPrev');
});

$('#arrow-next').click(function() {
$('.mitoq-slider-content-slider').slick('slickNext');
});
});

  } catch(e) { console.error(e); }
})();
})();
